"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var next_components_1 = require("@dotdev/next-components");
var Layouts = require("layouts");
var React = require("react");
var Snippets = require("snippets");
var AboutPageTemplate = /** @class */ (function (_super) {
    __extends(AboutPageTemplate, _super);
    function AboutPageTemplate(props) {
        var _this = _super.call(this, props) || this;
        var sections = props.data && props.data.sections ? props.data.sections : null;
        _this.state = {
            sections: sections
        };
        return _this;
    }
    AboutPageTemplate.prototype.render = function () {
        var page = this.props.data.page;
        var sections = this.state.sections;
        return (React.createElement(Layouts.Theme, __assign({}, this.props), sections ? (React.createElement(next_components_1.ShopifyNext.Components.DynamicSections, __assign({}, this.props))) : (React.createElement(React.Fragment, null,
            React.createElement(Snippets.Container, { tag: "section", className: "flex flex-col md:flex-row items-center py-2-4" },
                React.createElement("div", { className: "hidden md:block w-1/3" },
                    React.createElement(Snippets.Breadcrumbs, __assign({}, this.props))),
                React.createElement("div", { className: "w-full w-1/3 text-center" }, page.title ? (React.createElement(Snippets.Heading, { size: "h4", tag: "h1", className: "uppercase font-medium uppercase" }, page.title)) : null),
                React.createElement("div", { className: "hidden md:block w-1/3" })),
            React.createElement(Snippets.Container, { tag: "section", width: "sm", className: "md:pb-2-4" }, page.content ? React.createElement(Snippets.RichText, { size: "small" }, page.content) : null)))));
    };
    return AboutPageTemplate;
}(React.Component));
exports.AboutPageTemplate = AboutPageTemplate;
